module.exports = __webpack_public_path__ + "img/shoulder width.a9825e27.png";